/*
 * @Author: liyifan 
 * @Date: 2024-06-19 17:08:54 
 * @Last Modified by: liyifan
 * @Last Modified time: 2024-08-30 14:58:43
 * @description: 首页-博客推荐
 */
import './index.less'

import { isMobile  } from '@utils/index.js'
class BlogsSwiper {
    constructor() {
        this.init();
    }
    init() {
        const blogsSwiper = $('.blogs-swiper');
        if (blogsSwiper.length === 0) return
        new Swiper('.blogs-swiper', {
            spaceBetween: 32,		
            slidesPerView: 1.2,
            slideToClickedSlide: true,
            autoplay: false,
            freeMode: !isMobile(),
            speed: isMobile() ? 600 :3000,
            loop: isMobile(),
            breakpoints: {
                1024: {
                    spaceBetween: 20,		
                    slidesPerView: 3, 
                }
            },
            pagination: {
                el: '.blogs-pagination',
            }
        })
    }
}

$(function() {
    new BlogsSwiper()
})
